(() => {
  const normalizeStatus = (value) => String(value || '').trim().toLowerCase();
  const asText = (value) => String(value ?? '').trim();

  const createRow = (label, value) => {
    const text = asText(value);
    if (!text) return null;
    const row = document.createElement('div');
    const dt = document.createElement('dt');
    const dd = document.createElement('dd');
    dt.textContent = label;
    dd.textContent = text;
    row.append(dt, dd);
    return row;
  };

  const createDocuments = (documents) => {
    const links = Array.isArray(documents) ? documents.filter((doc) => doc && doc.url && doc.label) : [];
    if (!links.length) {
      const empty = document.createElement('p');
      empty.className = 'elixir-lot-card__empty-docs';
      empty.textContent = 'No public report files are available for this lot.';
      return empty;
    }
    const wrap = document.createElement('div');
    wrap.className = 'elixir-lot-card__documents';
    links.forEach((doc) => {
      const link = document.createElement('a');
      link.className = 'button button--secondary';
      link.href = doc.url;
      link.textContent = doc.label;
      wrap.appendChild(link);
    });
    return wrap;
  };

  const createLotCard = (lot, { archived = false } = {}) => {
    const card = document.createElement(archived ? 'details' : 'article');
    card.className = archived ? 'elixir-lot-card elixir-lot-card--archived' : 'elixir-lot-card';
    if (archived) {
      const summary = document.createElement('summary');
      summary.textContent = [lot.lotNumber, lot.releaseDate].filter(Boolean).join(' · ') || 'Historical lot';
      card.appendChild(summary);
    }
    const dl = document.createElement('dl');
    [['Release date', lot.releaseDate], ['Testing laboratory', lot.testingLab], ['Purity', lot.purity], ['Identity', lot.identity]].forEach(([label, value]) => {
      const row = createRow(label, value);
      if (row) dl.appendChild(row);
    });
    if (dl.children.length) card.appendChild(dl);
    card.appendChild(createDocuments(lot.documents));
    return card;
  };

  document.querySelectorAll('[data-elixir-product]').forEach((root) => {
    const lotScript = root.querySelector('[data-elixir-lots-json]');
    const lots = (() => {
      try { return JSON.parse(lotScript?.textContent || '[]'); }
      catch (error) { console.warn('ELIXIR product lot JSON could not be parsed.', error); return []; }
    })();

    const variantInput = root.querySelector('[data-variant-id-input]');
    const selectors = [...root.querySelectorAll('[data-variant-selector]')];
    const mediaItems = [...root.querySelectorAll('[data-product-media-id]')];
    const thumbnails = [...root.querySelectorAll('[data-product-thumbnail]')];
    const priceTarget = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const stickyBar = root.querySelector('[data-mobile-sticky-atc]');
    const stickyTitle = root.querySelector('[data-sticky-title]');
    const stickyVariant = root.querySelector('[data-sticky-variant]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyTier = root.querySelector('[data-sticky-tier]');
    const stickyImage = root.querySelector('[data-sticky-image]');
    const stickyButton = root.querySelector('[data-sticky-add-button]');
    const stickyVariantSelect = root.querySelector('[data-sticky-variant-select]');
    const stickyTierSelect = root.querySelector('[data-sticky-tier-select]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const tierCards = [...root.querySelectorAll('[data-tier-card]')];
    const tierSummary = root.querySelector('[data-tier-summary]');
    const waitlistPanel = root.querySelector('[data-waitlist-panel]');
    const productForm = root.querySelector('[data-elixir-product-form]');
    const purchasePanel = root.querySelector('.elixir-product__purchase-panel');
    const footer = document.querySelector('.site-footer');
    const statusTarget = root.querySelector('[data-lot-status-message]');
    const currentTarget = root.querySelector('[data-current-lot-container]');
    const archivedTarget = root.querySelector('[data-archived-lots-container]');
    const initialVariantId = root.dataset.initialVariantId;

    const formatMoney = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
    const discountForQuantity = (quantity) => quantity >= 10 ? 20 : quantity >= 5 ? 10 : quantity >= 3 ? 5 : 0;
    const totalAfterDiscount = (unitCents, quantity) => {
      const subtotal = Number(unitCents || 0) * Number(quantity || 1);
      const discount = discountForQuantity(quantity);
      return Math.round(subtotal * (100 - discount) / 100);
    };
    const activeVariant = () => selectors.find((input) => input.checked) || selectors[0];
    const updateTierCards = (input = activeVariant()) => {
      const cents = Number(input?.dataset.priceCents || 0);
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      tierCards.forEach((card) => {
        const cardQty = Number(card.dataset.tierQuantity || 1);
        const total = cents * cardQty;
        const discount = Number(card.dataset.tierDiscount || 0);
        const discountedTotal = totalAfterDiscount(cents, cardQty);
        const price = card.querySelector('[data-tier-price]');
        const originalPrice = card.querySelector('[data-tier-original-price]');
        if (price) price.textContent = formatMoney(discountedTotal);
        if (originalPrice) {
          originalPrice.textContent = formatMoney(total);
          originalPrice.hidden = discount <= 0;
        }
        const active = cardQty === quantity || (quantity > 10 && cardQty === 10);
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      const label = quantity >= 10 ? 'BUY 10' : quantity >= 5 ? 'BUY 5' : quantity >= 3 ? 'BUY 3' : 'BUY 1';
      if (stickyTier) stickyTier.textContent = label;
      if (stickyTierSelect) stickyTierSelect.value = String(quantity >= 10 ? 10 : quantity >= 5 ? 5 : quantity >= 3 ? 3 : 1);
      if (stickyPrice) stickyPrice.textContent = `${formatMoney(totalAfterDiscount(cents, quantity))} total`;
    };

    const showMedia = (mediaId) => {
      if (!mediaItems.length) return;
      const targetId = asText(mediaId) || asText(mediaItems[0]?.dataset.productMediaId);
      let matched = false;
      mediaItems.forEach((item) => {
        const active = asText(item.dataset.productMediaId) === targetId;
        matched = matched || active;
        item.classList.toggle('is-active', active);
      });
      if (!matched && mediaItems[0]) mediaItems[0].classList.add('is-active');
      thumbnails.forEach((button) => button.classList.toggle('is-active', asText(button.dataset.productThumbnail) === targetId));
    };

    const syncSticky = (input) => {
      if (!input) return;
      const available = input.dataset.available === 'true';
      if (stickyTitle) stickyTitle.textContent = root.dataset.productTitle || stickyTitle.textContent;
      if (stickyVariant) stickyVariant.textContent = input.closest('[data-variant-option-label]')?.textContent.trim() || '';
      if (stickyPrice && input.dataset.price) stickyPrice.textContent = input.dataset.price;
      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? 'ADD' : 'OUT OF STOCK';
      }
      if (waitlistPanel) waitlistPanel.hidden = available;
      if (stickyImage && input.dataset.imageUrl) stickyImage.src = input.dataset.imageUrl;
      if (stickyVariantSelect) stickyVariantSelect.value = input.value;
      updateTierCards(input);
    };

    thumbnails.forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.productThumbnail)));

    const renderLotsForVariant = (variantId) => {
      const currentLots = lots.filter((lot) => asText(lot.variantId) === asText(variantId)
        && normalizeStatus(lot.status) === 'current' && lot.publicEligible === true);
      currentTarget.replaceChildren();
      archivedTarget.replaceChildren();
      statusTarget.textContent = currentLots.length
        ? 'Lot-specific laboratory documentation for the selected mass.'
        : 'No public COA record is currently displayed for this product selection. Use COA Lookup to search by lot number or product name.';
      currentLots.forEach((lot) => {
        const card = createLotCard(lot, { archived: true });
        card.className = 'elixir-lot-card elixir-lot-card--compact';
        card.open = currentLots.length === 1;
        card.querySelector('summary').textContent = `Lot ${lot.lotNumber} · COA & reports`;
        currentTarget.appendChild(card);
      });
    };

    const selectVariant = (input) => {
      if (!input) return;
      const variantId = input.value;
      if (variantInput) variantInput.value = variantId;
      if (priceTarget && input.dataset.price) priceTarget.textContent = input.dataset.price;
      if (addButton) {
        const available = input.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart' : 'OUT OF STOCK';
      }
      syncSticky(input);
      showMedia(input.dataset.mediaId);
      renderLotsForVariant(variantId);
    };

    selectors.forEach((input) => input.addEventListener('change', () => selectVariant(input)));
    stickyVariantSelect?.addEventListener('change', () => {
      const target = selectors.find((input) => input.value === stickyVariantSelect.value);
      if (target && !target.disabled) {
        target.checked = true;
        selectVariant(target);
      }
    });
    tierCards.forEach((card) => card.addEventListener('click', () => {
      const quantity = Math.max(1, Number(card.dataset.tierQuantity || 1));
      if (quantityInput) quantityInput.value = String(quantity);
      updateTierCards(activeVariant());
    }));
    stickyTierSelect?.addEventListener('change', () => {
      const quantity = Math.max(1, Number(stickyTierSelect.value || 1));
      if (quantityInput) quantityInput.value = String(quantity);
      updateTierCards(activeVariant());
    });
    if (quantityInput) quantityInput.addEventListener('input', () => updateTierCards(activeVariant()));
    const selected = selectors.find((input) => input.checked) || selectors.find((input) => input.value === initialVariantId) || selectors[0];
    selectVariant(selected);

    if (stickyBar && purchasePanel && 'IntersectionObserver' in window) {
      let panelPast = false;
      let footerVisible = false;
      let inputFocused = false;
      const updateStickyVisibility = () => {
        const shouldShow = panelPast && !footerVisible && !inputFocused;
        stickyBar.classList.toggle('is-visible', shouldShow);
        stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };
      const panelObserver = new IntersectionObserver(([entry]) => {
        panelPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateStickyVisibility();
      }, { threshold: 0.08 });
      panelObserver.observe(purchasePanel);
      if (footer) {
        const footerObserver = new IntersectionObserver(([entry]) => {
          footerVisible = entry.isIntersecting;
          updateStickyVisibility();
        }, { threshold: 0.01 });
        footerObserver.observe(footer);
      }
      root.addEventListener('focusin', (event) => {
        if (event.target.matches('input, textarea, select')) { inputFocused = true; updateStickyVisibility(); }
      });
      root.addEventListener('focusout', () => { inputFocused = false; updateStickyVisibility(); });
      window.addEventListener('resize', updateStickyVisibility, { passive: true });
      updateStickyVisibility();
    }

    if (stickyButton && productForm) {
      stickyButton.addEventListener('click', () => {
        if (addButton && !addButton.disabled) addButton.focus({ preventScroll: true });
      });
    }
  });
})();
